import { Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DatePipe } from '@angular/common';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { MasterConstants } from './../../../../common/constants/master-constants';
import { GrowerDealerAuditService } from './../../../../services/seed/reports/grower-dealer-audit.service';
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';
import { CommonService } from './../../../../services/common/common.service';
import * as $ from 'jquery';
import { ReportType } from '../../../../models/report-type.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';


@Component({
  selector: 'app-dealer-order-audit',
  templateUrl: './dealer-order-audit.component.html',
  styleUrls: ['./dealer-order-audit.component.scss']
})
export class DealerOrderAuditComponent implements OnInit, OnDestroy {
  @ViewChild('productPaginator', { read: MatPaginator }) productPaginator: MatPaginator;
  @ViewChild('productTable', { read: MatSort }) productSort: MatSort;

  private subscription = new Array<Subscription>();
  originalDisplayedColumns: Array<ColumnDescription> = [
    { columnfield: 'itemNumber', headertxt: 'Item' },
    { columnfield: 'productName', headertxt: 'Product Name' },
    { columnfield: 'seedSize', headertxt: 'Seed Size' },
    { columnfield: 'treatment', headertxt: 'Treatment' },
    { columnfield: 'packageSize', headertxt: 'Package Size' },
    { columnfield: 'marketingBrand', headertxt: 'Marketing Brand' },
    { columnfield: 'auditDate', headertxt: 'Audit Date' },
    { columnfield: 'auditTime', headertxt: 'Audit Time' },
    { columnfield: 'orderNo', headertxt: 'Order Number' },
    { columnfield: 'parentAccountNo', headertxt: 'Parent Account Number' },
    { columnfield: 'accountNumber', headertxt: 'Account Number' },
    { columnfield: 'accountName', headertxt: 'Account Name' },
    { columnfield: 'city', headertxt: 'Account City' },
    { columnfield: 'accountState', headertxt: 'Account State' },
    { columnfield: 'explanation', headertxt: 'Explanation' },
    { columnfield: 'action', headertxt: 'Action' },
    { columnfield: 'transactionId', headertxt: 'TransactionID' },
    { columnfield: 'quantity', headertxt: 'Quantity' },
    { columnfield: 'changeQty', headertxt: 'Change Qty' },
    //{ columnfield: 'eaUnits', headertxt: 'EA Units' },
    //{ columnfield: 'changeEAUnits', headertxt: 'Change EA Units' },
    { columnfield: 'updatedBy', headertxt: 'Modified By' },
    { columnfield: 'implementationSpecialist', headertxt: 'Implementation Specialist' },
    { columnfield: 'accountManager', headertxt: 'Account Manager' },
    { columnfield: 'salesEnablementCDS', headertxt: 'Sales Enablement/CDS' },
    { columnfield: 'asmbuLead', headertxt: 'ASM/BU Lead' },
    { columnfield: 'secdsLead', headertxt: 'SE/CDS Lead' }
  ];

  //Common
  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;

  // Account Dropdown
  ddlAccounts: any;
  accountsLoading = false;

  // Filter
  selectedValue: string;
  isTextBoxEmpty = true;
  productFilters: any;
  filterValueList = new Array();
  previousSelectedValue: string;
  searchValue = '';
  partialSearchValue = '';
  // productMasterList: any = [];
  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  packagesizeMasterList: any = [];
  technologyMasterList: any = [];
  treatmentMasterList: any = [];
  maturityMasterList: any = [];
  productLineMasterList: any = [];
  explanationList: any = [];
  headerSubscription: any;
  isEvolveAccountRestriction = false;
  evolveUserId = '';
  accountNoList: any = [];
  orderNoList: any = [];
  dealerAuditDataSource: any;
  dealerAuditList: any = [];
  fromDateFilter: any;
  toDateFilter: any;
  salesGenericLevel: any;
  impDisplayName: any;
  filter: DealerOrderAuditLogFilter = new DealerOrderAuditLogFilter();

  comparisonType: any[] = [{ value: '<' }, { value: '>' }, { value: '=' }, { value: '>=' }, { value: '<=' }, { value: '<>' }];
  public currentFilter = new UserReportFilter();

  displayedColumns: string[] = this.originalDisplayedColumns.map(x => x.columnfield);
  searchTypeList: string[] = [];

  constructor(private growerDealerAuditService: GrowerDealerAuditService,
    private localStorageService: LocalStorageService,
    private loaderService: LoaderService,
    private datePipe: DatePipe,
    private excelService: ExcelService,
    private commonService: CommonService,
    private toastrService: ToastrService,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
    this.filter.changeQtyAction = '<';
  }

  ngOnInit() {
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      this.salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.impDisplayName = this.salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_Display).value;

      this.originalDisplayedColumns = [
        { columnfield: 'itemNumber', headertxt: 'Item' },
        { columnfield: 'productName', headertxt: 'Product Name' },
        { columnfield: 'seedSize', headertxt: 'Seed Size' },
        { columnfield: 'treatment', headertxt: 'Treatment' },
        { columnfield: 'packageSize', headertxt: 'Package Size' },
        { columnfield: 'marketingBrand', headertxt: 'Marketing Brand' },
        { columnfield: 'auditDate', headertxt: 'Audit Date' },
        { columnfield: 'auditTime', headertxt: 'Audit Time' },
        { columnfield: 'orderNo', headertxt: 'Order Number' },
        { columnfield: 'parentAccountNo', headertxt: 'Parent Account Number' },
        { columnfield: 'accountNumber', headertxt: 'Account Number' },
        { columnfield: 'accountName', headertxt: 'Account Name' },
        { columnfield: 'city', headertxt: 'Account City' },
        { columnfield: 'accountState', headertxt: 'Account State' },
        { columnfield: 'explanation', headertxt: 'Explanation' },
        { columnfield: 'action', headertxt: 'Action' },
        { columnfield: 'transactionId', headertxt: 'TransactionID' },
        { columnfield: 'quantity', headertxt: 'Quantity' },
        { columnfield: 'changeQty', headertxt: 'Change Qty' },
        //{ columnfield: 'eaUnits', headertxt: 'EA Units' },
        //{ columnfield: 'changeEAUnits', headertxt: 'Change EA Units' },
        { columnfield: 'updatedBy', headertxt: 'Modified By' },
        { columnfield: 'implementationSpecialist', headertxt: this.impDisplayName },
        { columnfield: 'accountManager', headertxt: 'Account Manager' },
        { columnfield: 'salesEnablementCDS', headertxt: 'Sales Enablement/CDS' },
        { columnfield: 'asmbuLead', headertxt: 'ASM/BU Lead' },
        { columnfield: 'secdsLead', headertxt: 'SE/CDS Lead' }
      ];

      this.displayedColumns = this.originalDisplayedColumns.map(x => x.columnfield);
    }

    this.getAccountList();
    this.loadMasterData();
    this.resetAuditFilter();
    this.getEvolveAccess();
    this.setSearchTypeList();
    this.selectedValue = this.searchTypeList[0];

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.currentFilter = filter;

          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.productFilters = filters.filterOption;
          this.displayedColumns = filters.displayedColumns.map(x => x.columnfield);
          this.getDealerOrderAuditLog();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setDealerOrderTableHeight();
  }

  //Set Account Table Height
  setDealerOrderTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.form-sec').outerHeight() - $('.fulfill-top-sec').outerHeight() - 200;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }

  setSearchTypeList() {
    if (this.isEvolveAccountRestriction) {
      this.searchTypeList = ['Order Number', 'Change Quantity', 'Product Name', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Item Number', 'Account', 'City', 'Maturity', 'Product Line', 'Duration', 'Explanation', 'TransactionID'];
    }
    else {
      this.searchTypeList = ['Order Number', 'Change Quantity', 'Product Name', 'Marketing Brand', 'Seed Size', 'Package Size', 'Technology', 'Treatment', 'Item Number', 'Account No', 'Account Name', 'City', 'Maturity', 'Product Line', 'Duration', 'Explanation', 'TransactionID'];
    }
  }

  ngOnDestroy() {
    if (this.headerSubscription) {
      this.headerSubscription.unsubscribe();
    }

    this.userReportFilterSliderService.resetFilter();
    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  getEvolveAccess() {
    const validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    const sessionData = validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.evolveAccountRestriction = sessionData.evolveAccountRestriction;
    this.filter.userId = sessionData.userId;
    this.evolveUserId = sessionData.userId;
  }

  // Bind Account list
  getAccountList() {
    this.accountsLoading = true;
    this.growerDealerAuditService.getDealerAuditAccountList().subscribe((result: any[]) => {
      this.ddlAccounts = result;
      this.accountsLoading = false;
    }, error => LolLoggerService.error(error));
  }

  // Enable Disable Search
  enableDisableSearch() {
    if (this.validateFilter(this.productFilters)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Brand Search
  validateBrandSearch() {
    // To Validate Brand
    if (this.productFilters.Brand !== null
      && this.productFilters.Brand !== ''
      && this.productFilters.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Technology Search
  validateTechnologySearch() {
    // To Validate Technology
    if (this.productFilters.TechnologyList !== null
      && this.productFilters.TechnologyList !== ''
      && this.productFilters.TechnologyList.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // to validate filter
  validateFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Technology
    if (productFilter.TechnologyList != null && productFilter.TechnologyList !== '' && productFilter.TechnologyList.toString().trim().length >= 2) {
      isValid = true;
    }
    // To Validate Explanation
    if (productFilter.ExplanationList != null && productFilter.ExplanationList.length > 0) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate Maturity Min & Max
    if (productFilter.MaturityMin != null && productFilter.MaturityMax != null) {
      isValid = true;
    }
    if (this.selectedValue == 'Maturity' && (productFilter.MaturityMin != null && productFilter.MaturityMax == null)
      &&
      (productFilter.MaturityMin != null && productFilter.MaturityMax == null)) {
      isValid = false;
    }

    // To Validate From Date
    if (productFilter.FromDate != null) {
      isValid = true;
    }

    // To Validate To Date
    if (productFilter.ToDate != null) {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }
    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TechnologyList == null)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.ExplanationList == null || productFilter.ExplanationList.length <= 0)
      && (productFilter.MaturityMin == null)
      && (productFilter.MaturityMax == null)
      && (productFilter.FromDate == null)
      && (productFilter.ToDate == null)
    ) {
      isValid = false;
    }
    return isValid;
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const changeQtyRegx = RegExp('^[0-9]+$');
    return ((this.productFilters.TxtAccountNo ? accountRegx.test(this.productFilters.TxtAccountNo) : true) &&
      (this.productFilters.ChangeQty ? changeQtyRegx.test(this.productFilters.ChangeQty) : true));
  }

  // Keep Filter Value
  keepFilter(selectedObj: any, type: string) {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';
      if (selectedObj && selectedObj.selectedValues) {
        const selectedValues = selectedObj.selectedValues as any[];
        selectedValues.forEach(x => { selectedIds = selectedIds + (type == 'AccountNo' ? x.accountNumber : x.id) + ','; });
      }

      switch (type) {
        case 'MarketingBrand':
          this.filter.marketingBrand = selectedIds;
          break;
        case 'SeedSize':
          this.filter.seedSize = selectedIds;
          break;
        case 'PackageSize':
          this.filter.packageSize = selectedIds;
          break;
        case 'Technology':
          this.filter.technology = selectedIds;
          break;
        case 'Treatment':
          this.filter.treatment = selectedIds;
          break;
        case 'ProductLine':
          this.filter.productLine = selectedIds;
          break;
        case 'ItemNo':
          this.filter.itemNo = selectedIds;
          break;
        case 'Explanation':
          this.filter.explanation = selectedIds;
          break;
      }

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.productFilters) {
        if (this.productFilters.Brand && this.productFilters.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.productFilters.Brand);
          this.filter.productName = this.productFilters.Brand;
        }
        // Set Item No
        if (this.productFilters.ItemNo && this.productFilters.ItemNo.length > 0) {
          var strMB = '';
          this.productFilters.ItemNo.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Item No : ' + strMB.substr(0, strMB.length - 2));
        }
        // Set Order No
        if (this.productFilters.OrderNo && this.productFilters.OrderNo != '') {
          this.filterValueList.push('Order No : ' + this.productFilters.OrderNo);
          this.filter.orderNo = this.productFilters.OrderNo;
        }

        // Set change Qty
        if (this.productFilters.ChangeQty && this.productFilters.ChangeQty != '' && this.filter.changeQtyAction) {
          this.filterValueList.push('Change Qty : ' + this.filter.changeQtyAction + ' ' + this.productFilters.ChangeQty);
          this.filter.changeQty = this.productFilters.ChangeQty;
        }
        if (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) {
          var strMB = '';
          this.productFilters.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));
        }
        if (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) {
          let strSS = '';
          this.productFilters.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));
        }
        if (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) {
          let strPS = '';
          this.productFilters.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
        }
        // Set Technology list
        if (this.productFilters.TechnologyList && this.productFilters.TechnologyList != '') {
          this.filterValueList.push('Technology : ' + this.productFilters.TechnologyList);
          this.filter.technology = this.productFilters.TechnologyList;
        }
        if (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) {
          let strTreat = '';
          this.productFilters.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));
        }

        if (this.productFilters.ExplanationList && this.productFilters.ExplanationList.length > 0) {
          let strExpl = '';
          this.productFilters.ExplanationList.forEach(x => {
            strExpl = strExpl + x + ', ';
          });
          this.filterValueList.push('Explanation : ' + strExpl.substr(0, strExpl.length - 2));
          // this.filter.explanation = strExpl.substr(0, strExpl.length - 2);
        }

        // text Account No
        if (this.productFilters.TxtAccountNo && this.productFilters.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.productFilters.TxtAccountNo);
          this.filter.account = this.productFilters.TxtAccountNo;
        }
        else if (this.productFilters.AccountNo && this.productFilters.AccountNo.length > 0) {
          let strAct = '';
          this.productFilters.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });

          if (this.isEvolveAccountRestriction) {
            this.filterValueList.push('Account : ' + strAct.substr(0, strAct.length - 2));
          }
          else {
            this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));
          }

          selectedIds = '';
          this.accountNoList.forEach(x => {
            if (this.productFilters.AccountNo.indexOf(x.accountNumber) > -1) {
              selectedIds = selectedIds + x.accountNumber + ',';
            }
          });
          if (this.productFilters.AccountNo == -1) {
            this.filter.account = '-1';
          }
          else {
            this.filter.account = selectedIds;
          }
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.productFilters.AccountName && this.productFilters.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.productFilters.AccountName);
          this.filter.accountName = this.productFilters.AccountName;
        }
        else {
          this.filter.accountName = null;
        }

        // City
        if (this.productFilters.City && this.productFilters.City != '') {
          this.filterValueList.push('City : ' + this.productFilters.City);
          this.filter.city = this.productFilters.City;
        }
        else {
          this.filter.city = null;
        }

        // TransactionID
        if (this.productFilters.TransactionID && this.productFilters.TransactionID != '') {
          this.filterValueList.push('TransactionID : ' + this.productFilters.TransactionID);
          this.filter.transactionID = this.productFilters.TransactionID;
        }
        else {
          this.filter.transactionID = null;
        }

        if (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) {
          let strPL = '';
          this.productFilters.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));
        }
        if (this.productFilters.MaturityMin != null && this.productFilters.MaturityMax != null) {
          this.filter.maturityMin = this.productFilters.MaturityMin;
          this.filter.maturityMax = this.productFilters.MaturityMax;

          this.filterValueList.push('Maturity : (' + this.productFilters.MaturityMin + ') - (' + this.productFilters.MaturityMax + ')');
        }

        if (this.productFilters.FromDate
          && this.productFilters.FromDate != null
          && this.productFilters.ToDate
          && this.productFilters.ToDate != null) {
          this.filterValueList.push('Duration : (' + this.datePipe.transform(this.productFilters.FromDate, 'MM-dd-yyyy') + ') - (' + this.datePipe.transform(this.productFilters.ToDate, 'MM-dd-yyyy') + ')');
          this.filter.fromDate = new Date(this.productFilters.FromDate).toDateString();
          this.filter.toDate = new Date(this.productFilters.ToDate).toDateString();
        }
      }
    }
    this.setDealerOrderTableHeight();
    if (this.productFilters && (this.productFilters.Brand != null && this.productFilters.Brand !== '') ||
      (this.productFilters.MarketingBrandList && this.productFilters.MarketingBrandList.length > 0) ||
      (this.productFilters.SeedSizeList && this.productFilters.SeedSizeList.length > 0) ||
      (this.productFilters.PackageSizeList && this.productFilters.PackageSizeList.length > 0) ||
      (this.productFilters.TechnologyList != null && this.productFilters.TechnologyList !== '') ||
      (this.productFilters.TreatmentList && this.productFilters.TreatmentList.length > 0) ||
      (this.productFilters.ProductLineList && this.productFilters.ProductLineList.length > 0) ||
      (this.productFilters.MaturityMin != null) ||
      (this.productFilters.MaturityMax != null)) {
      this.productFilters = this.getProductFilters(this.productFilters);
    }
    this.enableDisableSearch();

    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
  }

  // Get Product filter
  getProductFilters(productFilter) {
    this.productFilters.CompanyCode = this.headerCompany;
    this.productFilters.CropYear = this.headerYear;
    return productFilter;
  }

  // Load master data
  loadMasterData() {
    // Product master data
    // if (this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST)) {
    //  this.productMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_MASTER_LIST));
    // }

    // get Item Number List
    this.commonService.getItemNumbers().subscribe((result: any) => {
      this.orderNoList = result;
    });

    // MarketingBrand master data
    if (this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST)) {
      this.marketingMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MARKETING_BRAND_MASTER_LIST));
    }

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.SEED_SIZE_MASTER_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PACKAGE_SIZE_MASTER_LIST));
    }

    // Technology master data
    if (this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST)) {
      this.technologyMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TECHNOLOGY_MASTER_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.TREATMENT_MASTER_LIST));
    }

    // Maturity master data
    if (this.localStorageService.get(MasterConstants.MATURITY_LIST)) {
      this.maturityMasterList = JSON.parse(this.localStorageService.get(MasterConstants.MATURITY_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }
    // Explanation master data
    if (this.localStorageService.get(MasterConstants.ORDER_CHANGE_CODE_TYPE_MASTER_LIST)) {
      this.explanationList = JSON.parse(this.localStorageService.get(MasterConstants.ORDER_CHANGE_CODE_TYPE_MASTER_LIST));
    }

    this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as commonDDL;
      this.accountNoList = data.accounts;
    }, error => LolLoggerService.error(error));
  }

  // Reset Audit Filter
  resetAuditFilter() {
    this.productFilters = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'ItemNo': [],
      'OrderNo': null,
      'ChangeQty': null,
      'Brand': null,
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'PackageSizeList': [],
      'TechnologyList': null,
      'TreatmentList': [],
      'AccountName': null,
      'TxtAccountNo': null,
      'AccountNo': [],
      'ProductLineList': [],
      'MaturityMin': null,
      'MaturityMax': null,
      'FromDate': null,
      'ToDate': null,
      'City': null,
      'ExplanationList': [],
      'TransactionID': null
    };

    this.filter = {
      'companyCode': this.headerCompany,
      'cropYear': this.headerYear,
      'itemNo': null,
      'orderNo': null,
      'changeQty': null,
      'productName': null,
      'marketingBrand': null,
      'seedSize': null,
      'packageSize': null,
      'technology': null,
      'treatment': null,
      'accountName': null,
      'account': null,
      'maturityMin': null,
      'maturityMax': null,
      'productLine': null,
      'fromDate': null,
      'toDate': null,
      'evolveAccountRestriction': null,
      'userId': null,
      'includeChangeQtyZero': null,
      'changeQtyAction': null,
      'city': null,
      'transactionID': null,
      'explanation': null
    };
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeAuditFilter(filterValue);

      if (this.filterValueList.length < 1) {
        this.dealerAuditDataSource = new MatTableDataSource([]);
        this.dealerAuditDataSource.paginator = this.productPaginator;
        this.dealerAuditDataSource.sort = this.productSort;
      }
      this.enableDisableSearch();
    }
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.DealerOrderAudit, 0, this.originalDisplayedColumns, newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.DealerOrderAudit, 1, this.originalDisplayedColumns, newFilter);
  }

  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.DealerOrderAudit, 1, this.originalDisplayedColumns, this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.productFilters,
      filterValueList: this.filterValueList,
      displayedColumns: this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.subscription.push(this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
    else {
      this.subscription.push(this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
  }

  // To remove clear search filter
  removeAuditFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Item No':
        this.productFilters.ItemNo = null;
        this.filter.itemNo = null;
        break;
      case 'Order No':
        this.productFilters.OrderNo = null;
        this.filter.orderNo = null;
        break;
      case 'Change Qty':
        this.productFilters.ChangeQty = null;
        this.filter.changeQty = null;
        this.filter.changeQtyAction = null;
        break;
      case 'Product Name':
        this.productFilters.Brand = null;
        this.filter.productName = null;
        break;
      case 'Marketing Brand':
        this.productFilters.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'Seed Size':
        this.productFilters.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Package Size':
        this.productFilters.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Technology':
        this.productFilters.TechnologyList = null;
        this.filter.technology = null;
        break;
      case 'Treatment':
        this.productFilters.TreatmentList = [];
        this.filter.treatment = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account':
        if (this.isEvolveAccountRestriction) {
          this.productFilters.AccountNo = [];
        }
        else {
          this.productFilters.TxtAccountNo = null;
        }
        this.productFilters.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.productFilters.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'City':
        this.productFilters.City = null;
        this.filter.city = null;
        break;
      case 'Maturity':
        this.productFilters.MaturityMin = null;
        this.productFilters.MaturityMax = null;
        this.filter.maturityMin = null;
        this.filter.maturityMax = null;
        break;
      case 'Product Line':
        this.productFilters.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Duration':
        this.productFilters.FromDate = null;
        this.productFilters.ToDate = null;
        this.filter.fromDate = null;
        this.filter.toDate = null;
        this.fromDateFilter = '';
        this.toDateFilter = '';
        break;
      case 'TransactionID':
        this.productFilters.TransactionID = null;
        this.filter.transactionID = null;
        break;
      case 'Explanation':
        this.productFilters.ExplanationList = [];
        this.filter.explanation = null;
        break;
      default:
        break;
    }
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.isTextBoxEmpty = true;
    this.resetAuditFilter();
    this.validateDateFilter('clearAll', '');
    this.dealerAuditDataSource = new MatTableDataSource([]);
    this.dealerAuditDataSource.paginator = this.productPaginator;
    this.dealerAuditDataSource.sort = this.productSort;
    this.currentFilter = new UserReportFilter();
    this.userReportFilterSliderService.resetFilter();
    this.displayedColumns = this.originalDisplayedColumns.map(x => x.columnfield);
    //To Do clear grid
  }

  // Search the account details on Account dropdown
  accountSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }

  // Get dealer order audit
  getDealerOrderAuditLog() {
    this.keepFilter(null, '');

    if (!this.validateInputText()) {
      return false;
    }

    if ((this.filter.account == '-1') && (!this.filter.productName || this.filter.productName == '')
      && (!this.filter.itemNo || this.filter.itemNo != '')) {
      this.toastrService.error('Please specify a Product Name or Item Code before initiating a Search');
      return false;
    }

    // Set change Qty to -1 if change Action not selected
    if (!this.productFilters.ChangeQty || this.productFilters.ChangeQty == null) {
      this.filter.changeQty = -1;
    }

    if (!this.filter.evolveAccountRestriction) {
      this.filter.evolveAccountRestriction = false;
    }
    if (!this.filter.includeChangeQtyZero) {
      this.filter.includeChangeQtyZero = false;
    }

    this.loaderService.setLoaderStatus(true);
    this.filter.evolveAccountRestriction = this.isEvolveAccountRestriction;
    this.filter.userId = this.evolveUserId;

    this.growerDealerAuditService.getDealerOrderAuditLog(this.filter).subscribe((result: any) => {
      if (result) {
        this.dealerAuditList = result;
        this.dealerAuditDataSource = new MatTableDataSource(this.dealerAuditList);
        this.dealerAuditDataSource.paginator = this.productPaginator;
        this.dealerAuditDataSource.paginator.firstPage();
        this.dealerAuditDataSource.sort = this.productSort;
      }
      this.loaderService.setLoaderStatus(false);
    }, (error) => {
      this.loaderService.setLoaderStatus(false);
      LolLoggerService.error(error);
    });
  }

  // Export excel
  export() {
    this.loaderService.setLoaderStatus(true);
    var excelData = [];
    if (this.dealerAuditDataSource && this.dealerAuditDataSource.data.length > 0) {
      this.loaderService.setLoaderStatus(true);
      const headerText = this.displayedColumns.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x).headertxt);

      this.dealerAuditDataSource.data.forEach(x => {
        const exportData = new Map();
       
        headerText.forEach(y => {
          switch (y) {
            case 'Item': {
              exportData.set(y, x.itemNumber)
              break;
            }
            case 'Product Name': {
              exportData.set(y, x.productName)
              break;
            }
            case 'Seed Size': {
              exportData.set(y, x.seedSize)
              break;
            }
            case 'Treatment': {
              exportData.set(y, x.treatment)
              break;
            }
            case 'Package Size': {
              exportData.set(y, x.packageSize)
              break;
            }
            case 'Marketing Brand': {
              exportData.set(y, x.marketingBrand)
              break;
            }
            case 'Audit Date': {
              exportData.set(y, this.datePipe.transform(x.auditTime, 'MM-dd-yyyy'))
              break;
            }
            case 'Audit Time': {
              exportData.set(y, this.datePipe.transform(x.auditTime, 'h:mm:ss a'))
              break;
            }
            case 'Order Number': {
              exportData.set(y, x.orderNumber)
              break;
            }
            case 'Parent Account Number': {
              exportData.set(y, x.parentAccountNo)
              break;
            }
            case 'Account Number': {
              exportData.set(y, x.accountNumber)
              break;
            }
            case 'Account Name': {
              exportData.set(y, x.accountName)
              break;
            }
            case 'Account City': {
              exportData.set(y, x.city)
              break;
            }
            case 'Account State': {
              exportData.set(y, x.accountState)
              break;
            }
            case 'Explanation': {
              exportData.set(y, x.explanation)
              break;
            }
            case 'Action': {
              exportData.set(y, x.action)
              break;
            }
            case 'Quantity': {
              exportData.set(y, x.quantity)
              break;
            }
            case 'Change Qty': {
              exportData.set(y, x.changeQty)
              break;
            }
            //case 'EA Units': {
            //  exportData.set(y, x.eaUnits)
            //  break;
            //}
            //case 'Change EA Units': {
            //  exportData.set(y, x.changeEAUnits)
            //  break;
            //}
            case 'Modified By': {
              exportData.set(y, x.updatedBy)
              break;
            }
            case 'TransactionID': {
              exportData.set(y, x.transactionID)
              break;
            }
            case this.impDisplayName: {
              exportData.set(y, x.implementationSpecialist)
              break;
            }
            case 'Account Manager': {
              exportData.set(y, x.accountManager)
              break;
            }
            case 'Sales Enablement/CDS': {
              exportData.set(y, x.salesEnablementCDS)
              break;
            }
            case 'ASM/BU Lead': {
              exportData.set(y, x.asmbuLead)
              break;
            }
            case 'SE/CDS Lead': {
              exportData.set(y, x.secdsLead)
              break;
            }
            default: {
              break;
            }
          }
        });

        const obj = this.autoConvertMapToObject(exportData);
        excelData.push(
          obj
        );
      });

      setTimeout(x => {
        this.excelService.exportExcel(excelData, 'DealerOrderAuditReport');
        this.loaderService.setLoaderStatus(false);
      }, 100);
    }
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  validateDateFilter(contextFrom, $event) {
    if (contextFrom == 'fromDate') {
      fromDate = new Date($event.value);
      if (this.productFilters.ToDate) {
        var toDate = new Date(this.productFilters.ToDate);
        this.fromDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate <= toDate;
        };
      }
      this.toDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate >= fromDate;
      };
    }
    else if (contextFrom == 'toDate') {
      toDate = new Date($event.value);
      this.fromDateFilter = (d: Date): boolean => {
        const calendarDate = d;
        return calendarDate <= toDate;
      };
      if (this.productFilters.FromDate) {
        var fromDate = new Date(this.productFilters.FromDate);
        this.toDateFilter = (d: Date): boolean => {
          const calendarDate = d;
          return calendarDate >= fromDate;
        };
      }
    }
    else if (contextFrom == 'clearAll') {
      this.fromDateFilter = '';
      this.toDateFilter = '';
    }
  }
}

export class DealerOrderAuditLogFilter {
  companyCode: string;
  cropYear: number;
  itemNo: string;
  orderNo: string;
  changeQty: number;
  changeQtyAction: string;
  account: string;
  accountName: string;
  productName: string;
  marketingBrand: string;
  seedSize: string;
  packageSize: string;
  technology: string;
  treatment: string;
  maturityMin: string;
  maturityMax: string;
  productLine: string;
  fromDate: any;
  toDate: any;
  evolveAccountRestriction: boolean;
  userId: string;
  includeChangeQtyZero: boolean;
  city: string;
  explanation: string;
  transactionID: string;
}

export class commonDDL {
  accounts: any[];
  states: any[];
  userId: any[];
  distDSM: any[];
}
